<script>
  import Section from '../components/section.svelte';
  import Card from '../components/card.svelte';

  export let info = {};

  let name = '';
  let email = '';
  let message = '';
  let isSubmitting = false;
  let feedback = '';
  let feedbackType = '';

  function handleSubmit() {
    isSubmitting = true;
    feedback = '';
    
    // Mock submission - simulate network delay
    setTimeout(() => {
      // Simple validation
      if (!name.trim() || !email.trim() || !message.trim()) {
        feedback = 'Please fill in all fields.';
        feedbackType = 'error';
      } else if (!email.includes('@')) {
        feedback = 'Please enter a valid email address.';
        feedbackType = 'error';
      } else {
        feedback = 'Thank you for your message! I\'ll get back to you soon.';
        feedbackType = 'success';
        // Clear form on success
        name = '';
        email = '';
        message = '';
      }
      isSubmitting = false;
    }, 1500);
  }
</script>

<Section title="Contact" id="contact">
  <div class="contact-container">
    <Card>
      <div class="contact-form">
      <p class="contact-intro">
        Let's discuss your project! Whether you need system integrations, workflow automation, 
        or AI-powered solutions, I'm here to help.
      </p>
      
      <form on:submit|preventDefault={handleSubmit}>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="name" class="form-label">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              bind:value={name}
              placeholder="Your name"
              disabled={isSubmitting}
            />
          </div>
          <div class="col-md-6 mb-3">
            <label for="email" class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              bind:value={email}
              placeholder="your.email@example.com"
              disabled={isSubmitting}
            />
          </div>
        </div>
        
        <div class="mb-3">
          <label for="message" class="form-label">Message</label>
          <textarea
            class="form-control"
            id="message"
            rows="5"
            bind:value={message}
            placeholder="Tell me about your project, challenges, or how I can help..."
            disabled={isSubmitting}
          ></textarea>
        </div>

        {#if feedback}
          <div class="alert {feedbackType === 'success' ? 'alert-success' : 'alert-danger'} mb-3">
            {feedback}
          </div>
        {/if}

        <div class="text-center">
          <button 
            type="submit" 
            class="btn btn-outline-secondary"
            disabled={isSubmitting}
          >
            {#if isSubmitting}
              Sending...
            {:else}
              Send Message
            {/if}
          </button>
        </div>
      </form>
      </div>
    </Card>
  </div>
</Section>

<style>
  .contact-container {
    max-width: 700px;
    margin: 0 auto;
  }

  .contact-form {
    max-width: 500px;
    margin: 0 auto;
  }

  .contact-intro {
    text-align: center;
    margin-bottom: 2rem;
    color: var(--base00);
  }

  .form-label {
    font-weight: 500;
    color: var(--base00);
    margin-bottom: 0.5rem;
  }

  .form-control {
    border: 1px solid var(--base02);
    background-color: var(--background-color);
    color: var(--base00);
    padding: 0.75rem;
    border-radius: 0.375rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .form-control:focus {
    outline: 0;
    border-color: var(--base0A);
    box-shadow: 0 0 0 0.2rem rgba(var(--base0A-rgb), 0.25);
  }

  .form-control:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-control::placeholder {
    color: var(--base01);
  }

  .btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .alert {
    padding: 0.75rem 1rem;
    border-radius: 0.375rem;
    border: 1px solid transparent;
  }

  .alert-success {
    color: #0f5132;
    background-color: #d1e7dd;
    border-color: #badbcc;
  }

  .alert-danger {
    color: #842029;
    background-color: #f8d7da;
    border-color: #f5c2c7;
  }

  @media (max-width: 768px) {
    .contact-container {
      max-width: 100%;
      padding: 0 1rem;
    }
    
    .contact-form {
      max-width: 100%;
      padding: 0;
    }
  }
</style>